<form [formGroup]="form">
    <Table>
        <thead>
            <th>
                Field
            </th>
            <th>
                Current Value
            </th>
            <th>
                Desired Value
            </th>
            <th>
                Status
            </th>
        </thead>

        <tbody>
            <tr>
                <td>
                    Content can be optionally shared with SharePoint
                    <mat-icon matTooltip="Control how content is shared in SharePoint">
                        info
                    </mat-icon>
                </td>

                <td>
                    <mat-label>
                        {{sharingCapabilityMapping[data.SharingCapability]}}
                    </mat-label>


                </td>

                <td>
                    <mat-form-field>
                        <mat-select (selectionChange)="onSharingCapabilityChange()" formControlName="SharingCapability">
                            <!-- order from highest to lowest permission -->
                            <mat-option [value]="2">Anyone</mat-option>
                            <mat-option [value]="1">New and existing guests</mat-option>
                            <mat-option [value]="3">Existing guests</mat-option>
                            <mat-option [value]="0">Only people in your organization</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.SharingCapability != data.SharingCapability"></sway-baseline-status>

                </td>
            </tr>

            <tr>
                <td>
                    Content can be optionally shared with onedrive
                    <mat-icon matTooltip="Control how content is shared in OneDrive">
                        info
                    </mat-icon>
                </td>

                <td>
                    {{oneDriveSharingCapabilityMapping[data.OneDriveSharingCapability]}}
                </td>

                <td>
                    <mat-form-field>
                        <mat-select formControlName="OneDriveSharingCapability">
                            <!-- order from highest to lowest permission -->
                            <mat-option *ngIf="formValue.SharingCapability === 2" [value]="2">Anyone</mat-option>
                            <mat-option *ngIf="formValue.SharingCapability === 1 || formValue.SharingCapability === 2" [value]="1">New and existing guests</mat-option>

                            <mat-option *ngIf="formValue.SharingCapability !== 0" [value]="3">Existing guests</mat-option>

                            <mat-option [value]="0">Only people in your organization</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.OneDriveSharingCapability != data.OneDriveSharingCapability"></sway-baseline-status>

                </td>
            </tr>

            <tr>
                <td>
                    Default File and Folder Share Link Type
                    <mat-icon
                        matTooltip="Choose the type of link that's selected by default when users share files and folders in SharePoint and OneDrive.">
                        info
                    </mat-icon>
                </td>

                <td>

                    <mat-label>
                        {{defaultSharingLinkTypeMapping[data.DefaultSharingLinkType]}}
                    </mat-label>


                </td>

                <td>
                    <mat-form-field>
                        <mat-select formControlName="DefaultSharingLinkType">
                            <mat-option [value]="1">Specific people (only the people the user specifies)</mat-option>
                            <mat-option [value]="2">Only people in your organization </mat-option>
                            <mat-option [disabled]="+formValue.SharingCapability !== 2" [value]="3">Anyone with the link</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.DefaultSharingLinkType != data.DefaultSharingLinkType"></sway-baseline-status>

                </td>
            </tr>

            <tr>
                <td>
                    Default Sharing Link Permissions
                    <mat-icon matTooltip="Choose the permission that's selected by default for sharing links.">
                        info
                    </mat-icon>
                </td>

                <td>
                    <mat-label *ngIf="data.DefaultLinkPermission === 1">
                        View
                    </mat-label>

                    <mat-label *ngIf="data.DefaultLinkPermission === 2">
                        Edit
                    </mat-label>
                </td>

                <td>
                    <mat-form-field>
                        <mat-select formControlName="DefaultLinkPermission">
                            <mat-option [value]="1">View</mat-option>
                            <mat-option [value]="2">Edit</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.DefaultLinkPermission != data.DefaultLinkPermission"></sway-baseline-status>

                </td>
            </tr>

            <tr *ngIf="formValue.SharingCapability == 2">
                <td>
                    File Anonymous Link Type
                    <mat-icon matTooltip="Configure permission options for links that grant access to files for anyone.">
                        info
                    </mat-icon>
                </td>

                <td>

                    <mat-label *ngIf="data.FileAnonymousLinkType === 1">
                        View
                    </mat-label>


                    <mat-label *ngIf="data.FileAnonymousLinkType === 2">
                        View and edit
                    </mat-label>

                </td>

                <td>
                    <mat-form-field>
                        <mat-select formControlName="FileAnonymousLinkType">
                            <mat-option [value]="1">View</mat-option>
                            <mat-option [value]="2">View and edit</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.FileAnonymousLinkType != data.FileAnonymousLinkType"></sway-baseline-status>

                </td>
            </tr>

            <tr *ngIf="formValue.SharingCapability === 2">
                <td>
                    Folder Anonymous Link Type
                    <mat-icon matTooltip="Configure permission options for links that grant access to folders for anyone.">
                        info
                    </mat-icon>
                </td>

                <td>

                    <mat-label *ngIf="data.FolderAnonymousLinkType === 1">
                        View
                    </mat-label>


                    <mat-label *ngIf="data.FolderAnonymousLinkType === 2">
                        View, edit, and upload
                    </mat-label>

                </td>

                <td>
                    <mat-form-field>
                        <mat-select formControlName="FolderAnonymousLinkType">
                            <mat-option [value]="1">View</mat-option>
                            <mat-option [value]="2">View, edit, and upload</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.FolderAnonymousLinkType != data.FolderAnonymousLinkType"></sway-baseline-status>

                </td>
            </tr>
            <tr>
                <td>
                    Viewer Activity in OneDrive
                    <mat-icon matTooltip="Show owners the names of people who viewed their files in onedrive">
                        info
                    </mat-icon>
                </td>

                <td>

                    <mat-label>
                        {{data.DisplayNamesOfFileViewersInSpo ? 'Enabled' : 'Disabled'}}
                    </mat-label>


                </td>

                <td>
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="DisplayNamesOfFileViewersInSpo">
                            <mat-option [value]="true">Enabled</mat-option>
                            <mat-option [value]="false"> Disabled</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.DisplayNamesOfFileViewersInSpo != data.DisplayNamesOfFileViewersInSpo"></sway-baseline-status>

                </td>
            </tr>
            <tr>
                <td>
                    Viewer Activity in SharePoint
                    <mat-icon matTooltip="Show owners the names of people who viewed their files in Sharepoint">
                        info
                    </mat-icon>
                </td>

                <td>

                    <mat-label>
                        {{data.DisplayNamesOfFileViewers ? 'Enabled' : 'Disabled'}}
                    </mat-label>

                </td>

                <td>
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="DisplayNamesOfFileViewers">
                            <mat-option [value]="true">Enabled</mat-option>
                            <mat-option [value]="false"> Disabled</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="formValue.DisplayNamesOfFileViewers != data.DisplayNamesOfFileViewers"></sway-baseline-status>

                </td>
            </tr>

            <tr>
                <td>
                    External Users Resharing
                    <mat-icon
                        matTooltip="Prevents external users from resharing files, folders, and sites that they do not own.">
                        info
                    </mat-icon>
                </td>

                <td class="text-blue-600" colspan="3">
                    This parameter is controlled by the 'External (Guest) Users Resharing' baseline. We recommend using that baseline.

                </td>
            </tr>

            <tr>
                <td>
                    Link Expiry
                    <mat-icon matTooltip="Choose expiration and permissions options for Anyone links.">
                        info
                    </mat-icon>
                </td>

                <td colspan="3" class="text-blue-600">
                    This parameter is controlled by the 'Anonymous Links Expiry' baseline. We recommend using that baseline.


                </td>
            </tr>
        </tbody>

    </Table>
</form>
